import { MeasurementName } from '@quromedical/models';
import { getValue } from './internal';
import { interpret } from './interpreter';

/**
 * from https://www.ncbi.nlm.nih.gov/books/NBK538226
 *
 * MAP = DP + 1/3(SP – DP)
 */
const getMeanArterialPressure = (systolicBloodPressure, diastolicBloodPressure) => diastolicBloodPressure + 1 / 3 * (systolicBloodPressure - diastolicBloodPressure);

const resolveMeanArterialPressure = (relative, windowVitals) => {
  const systolic = getValue(windowVitals[MeasurementName.SystolicArterialBloodPressure]);
  const diastolic = getValue(windowVitals[MeasurementName.DiastolicArterialBloodPressure]);
  const hasUndefined = systolic === undefined || diastolic === undefined;

  if (hasUndefined) {
    return [];
  }

  const meanArterialPressure = getMeanArterialPressure(systolic, diastolic);
  return [{
    ts: relative,
    type: MeasurementName.MeanArterialBloodPressure,
    value: meanArterialPressure.toString()
  }];
};

const meanArterialPressureConfig = {
  window: 10000,
  base: MeasurementName.DiastolicArterialBloodPressure,
  resolve: resolveMeanArterialPressure
};
export const configurations = [meanArterialPressureConfig];
export const calculateBloodPressure = interpret(configurations);
//# sourceMappingURL=blood-pressure.js.map